import PageLayout from '../components/layout/PageLayout';
import Seo from '../components/Seo';
import './SecurityPage.css';

export default function SecurityPage() {
  return (
    <PageLayout title="Политика безопасности">
      <Seo
        title="Политика безопасности — Recvisit"
        description="Информация о мерах безопасности и защите данных в SaaS‑сервисе Recvisit."
        canonicalPath="/security"
      />
      <div className="container">
        <p className="sec-lead">
          Безопасность — ключевой принцип Recvisit. Ниже описаны основные организационные и технические меры, которые
          применяются для защиты данных и устойчивой работы сервиса.
        </p>

        <div className="sec-grid">
          <section className="sec-card">
            <h2 className="sec-h2">Защита передачи данных</h2>
            <ul className="sec-list">
              <li>защищенные каналы связи (HTTPS/TLS);</li>
              <li>контроль целостности и безопасные настройки серверов;</li>
              <li>ограничение доступа к административным интерфейсам.</li>
            </ul>
          </section>

          <section className="sec-card">
            <h2 className="sec-h2">Контроль доступа</h2>
            <ul className="sec-list">
              <li>разграничение прав доступа внутри сервиса;</li>
              <li>минимизация прав по принципу «необходимого доступа»;</li>
              <li>аудит действий (в пределах применимых журналов событий).</li>
            </ul>
          </section>

          <section className="sec-card">
            <h2 className="sec-h2">Хранение данных</h2>
            <ul className="sec-list">
              <li>размещение и обработка данных на территории Российской Федерации;</li>
              <li>резервное копирование и процедуры восстановления (в пределах архитектуры);</li>
              <li>мониторинг инфраструктуры и реагирование на инциденты.</li>
            </ul>
          </section>

          <section className="sec-card">
            <h2 className="sec-h2">Сообщение об уязвимостях</h2>
            <p className="sec-p">
              Если вы обнаружили уязвимость или подозрительную активность, пожалуйста, сообщите нам на{' '}
              <a href="mailto:info@recvi.ru">info@recvi.ru</a>. Мы рассмотрим сообщение и предпримем меры по устранению.
            </p>
          </section>
        </div>

        <div className="sec-note">
          Политика безопасности может обновляться по мере развития сервиса и изменения требований к защите информации.
        </div>
      </div>
    </PageLayout>
  );
}

